<template>
  <div :class="['t-filter-group', { 't-filter-group--clear': data.length > 0 }]">
    <input type="text" :placeholder="placeholder" v-model="data" v-on:keyup="onChange" />
    <div class="clear-icon icf-close" v-on:click="onClear"></div>
    <div class="search-icon icf-magnify"></div>
  </div>
</template>

<script setup lang="ts">
import { ACTION } from '@gd/tracking'
import { track } from '@/lib/track'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

withDefaults(defineProps<{ placeholder: string }>(), { placeholder: '' })
const emit = defineEmits(['on-change'])
const route = useRoute()
const data = ref('')
// since the search (aka "update") function is triggered on every character that is entered,
// we decided to track only once if the search has been used
const searchTracked = ref(false)

function update(value: string) {
  data.value = value
  emit('on-change', value)
}

function onChange(event: KeyboardEvent) {
  const searchTerm = (event.target as HTMLInputElement).value
  update(searchTerm)
  if (!searchTracked.value) {
    searchTracked.value = true
    track({
      id: 'search_input',
      path: route.fullPath,
      action: ACTION.change,
    })
  }
}

function onClear(event: MouseEvent) {
  update('')
  track({
    id: 'search_input',
    path: route.fullPath,
    action: ACTION.clear,
  })
}
</script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '~@npm/@gd/common-styles/lib/filter';
@import '~@npm/@gd/common-styles/lib/input';
.t-filter-group {
  .filter();
  input::-ms-clear {
    display: none;
  }
}
</style>
